import React from 'react';
import PropTypes from 'prop-types';
import NewReportsList from './NewReportsList';
import {Button, Menu} from 'antd';
import MaterialIcon from 'components/common/MaterialIcon';


@autobind
/**
 *
 * @class ReportsListContainer
 * @extends PureComponent
 */
export default class NewReportsListContainer extends React.PureComponent {
  static propTypes = {
    index: PropTypes.func,
    items: PropTypes.arrayOf(PropTypes.object),
    activeItem: PropTypes.number,
    onClick: PropTypes.func,
    onSearch: PropTypes.func,
    pagination: PropTypes.object,
    reload: PropTypes.func,
    onDelete: PropTypes.func,
    menu: PropTypes.func,
    loading: PropTypes.bool,
    extra: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.string,
    ]),
    onCreateForm: PropTypes.func,
  };

  /**
   *
   * @param {Object} item
   * @return {XML}
   * @private
   */
  _renderMenu(item) {
    const {can, onEdit, onTake, onDelete} = this.props;

    return (
        <Menu
            onClick={({key}) => {
              switch (key) {
                case 'takeReport':
                  onTake(item);
                  break;
                case 'edit':
                  onEdit(item);
                  break;
                case 'delete':
                default:
                  onDelete(item);
              }
            }}
        >
          <Menu.Item key="takeReport" disabled={!can('ReportBuilder@takeReport')}>
            <MaterialIcon name="content-copy"/>
            {app.translate('گرفتن گزارش')}
          </Menu.Item>
          <Menu.Item key="edit" disabled={!can('ReportBuilder@update')}>
            <MaterialIcon name="pencil"/>
            {app.translate('main.Edit')}
          </Menu.Item>
          <Menu.Item key="delete" disabled={!can('ReportBuilder@destroy')}>
            <MaterialIcon name="delete"/>
            {app.translate('main.Delete')}
          </Menu.Item>
        </Menu>
    );
  }


  /**
   *
   * @return {XML}
   */
  render() {
    const {activeItem, loading, onClick, items, menu , onSearch, pagination, reload, onCreateForm, activeRenewedCalculateForm, ...rest} = this.props;

    // const {...rest} = this.props;
    // let _props = app._.omit(rest, ['menu', 'extra', 'onEdit', 'onDelete', 'onReload', 'onAdd']);
    let extras = [];
    if(app.can('ReportBuilder@process')){
      extras.push(<Button type="primary"  key="form-renewedCalculate"  onClick={activeRenewedCalculateForm}>
        {app.translate('routes.home.attendance.reports.renewed calculate')}
      </Button>)
    }
    if(app.haveUiPermission(['reportBuilder'])){
      extras.push(<Button type="primary"  key="form-create"  onClick={()=>onClick(undefined)}>
        {app.translate('routes.home.attendance.reports.Add Report')}
      </Button>)
    }


    return (
      <NewReportsList
        items={items}
        loading={loading}
        onSearch={onSearch}
        pagination={pagination}
        activeItem={activeItem}
        onClick={onClick}
        // menu={menu}
        menu={this._renderMenu}
        extra={[
            ...extras,
          <Button type="dashed" key="reload" onClick={reload}>
            <MaterialIcon name="reload" spin={loading}/>
          </Button>,
        ]}
        {...rest}
      />
    );
  }
}
